'use strict'

import alertmodal from './alertmodal.js'

const config = require('AppConfig')
const message = require('./config/message')

export default {
    methods: {
        /**
         * GETパラメータの値を取得
         * @param {string} name パラメータ名
         * @returns {string} パラメータの値
         */
        getParameterByName: function(name) {
            name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
            let regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
            let results = regex.exec(location.search)
            return results == null
                ? ''
                : decodeURIComponent(results[1].replace(/\+/g, ' '))
        },

        /**
         * タイトルを設定
         * @param {string}} title タイトル
         * @returns {void}
         */
        setTitle: function(title) {
            let siteTitleSuffix = ' | ツギノジダイ'
            document.title = `${title}${siteTitleSuffix}`
        },

        /**
         * Vueを表示
         * @returns {void}
         */
        showApp: function() {
            document.querySelector('#app').style.display = ''
        },

        /**
         * 実行結果を表示
         * @param {number} stat 1:success, 2:error
         * @param {string} msg メッセージ
         * @returns {void}
         */
        setResult: function(stat, msg) {
            // ローディングを削除
            alertmodal.removeLoading()

            // アラートを表示
            alertmodal.showAlert(msg, stat == 2 ? 'error' : 'success')
        },

        /**
         * テキストメッセージを表示
         * @param {string} msg メッセージ
         * @returns {void}
         */
        displayTextMessage: function(
            router,
            msg,
            caption01,
            caption02,
            regist
        ) {
            router.push({
                name: 'message',
                params: {
                    message: msg,
                    caption01: caption01,
                    caption02: caption02,
                    regist: regist
                }
            })

            // ローディングを削除
            alertmodal.removeLoading()
        },

        /**
         * リダイレクトを実行
         * @param {string} redirectTo リダイレクト先のパス
         * @returns {void}
         */
        setRedirectTimer: function(redirectTo = config.path.profile) {
            // リダイレクト前にその旨を表示
            alertmodal.showAlert('画面が自動で切り替わります。', 'success')
            setInterval(function() {
                location.href = redirectTo
            }, 3000)
        },

        /**
         * パスワード変更ページへリダイレクト
         * @returns {void}
         */
        changepasswd: function() {
            location.href = config.path.changepasswd
        },

        /**
         * 退会ページへリダイレクト
         * @returns {void}
         */
        withdrawal: function() {
            location.href = config.path.withdrawal
        },

        /**
         * 現在日時を取得
         * @returns {string} 現在日時
         */
        getCurrentDate: function() {
            let now = new Date()
            let year = now.getFullYear()
            let month = now.getMonth() + 1
            let date = now.getDate()
            let hour = now.getHours()
            let min = now.getMinutes()
            let sec = now.getSeconds()
            return `${year}/${month}/${date} ${hour}:${min}:${sec}`
        },

        /**
         * メッセージを取得
         * @param {string} type メッセージタイプ
         * @param {number} stat 1:success, 2:error
         * @param {string} errorCode エラーコード
         * @returns {string} メッセージ
         */
        getMessage: function(type, stat, errorCode = '') {
            let msg = ''
            if (message[type]) {
                if (stat == 1) {
                    msg = message[type].success
                } else if (errorCode != '') {
                    if (message[type].error_code[errorCode]) {
                        msg = message[type].error_code[errorCode]
                    } else {
                        msg = message[type].error
                    }
                } else {
                    msg = message[type].error
                }
            }
            return msg
        },

        /**
         * recaptcha用の処理
         * @returns {void}
         */
        recaptcha: function() {
            return typeof grecaptcha != 'undefined'
                ? new Promise(function(resolve, reject) {
                      if (typeof grecaptcha != 'undefined') {
                          grecaptcha.ready(function() {
                              grecaptcha
                                  .execute(config.recaptchaSiteKey)
                                  .then(function(token) {
                                      var recaptchaResponse = document.getElementById(
                                          'recaptchaResponse'
                                      )
                                      resolve()
                                      recaptchaResponse.value = token
                                  })
                          })
                      }
                  })
                : Promise.resolve()
        },

        /**
         * ユーザインサイトの再発火
         * @returns {void}
         */
        rerunUserInsight: function() {
            if (typeof _uic != 'undefined' && typeof _uih != 'undefined') {
                _uih['url'] = document.URL
                _uih['sb'] = document.title
                _uih['ref'] = document.referrer

                if ((typeof _uic['send_pv']).toLowerCase() == 'function') {
                    _uic['send_pv'](_uih, _uic)
                }
            }
        }
    }
}
